import { render } from "./escolasCadastrar.vue?vue&type=template&id=573e68fa"
import script from "./escolasCadastrar.vue?vue&type=script&lang=js"
export * from "./escolasCadastrar.vue?vue&type=script&lang=js"

import "./escolasCadastrar.vue?vue&type=style&index=0&id=573e68fa&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__